import { UserCompany } from '../services/auth.service';

export function getVisibleUserCompanies(
  userCompanies: UserCompany[] | null | undefined
): UserCompany[] {
  return (userCompanies ?? []).filter((uc) => uc.isHidden !== true);
}

export function getUserCompanyId(userCompany: UserCompany): string | null {
  const nested = userCompany.company?.id;
  return userCompany.companyId || nested || null;
}

export function findPrimaryUserCompany(
  userCompanies: UserCompany[] | null | undefined
): UserCompany | null {
  return getVisibleUserCompanies(userCompanies).find((uc) => uc.isPrimary === true) ?? null;
}

export type StudiesOrgDecision = 'allowed' | 'select-company';

export function hasMultipleVisibleCompanies(
  userCompanies: UserCompany[] | null | undefined
): boolean {
  return getVisibleUserCompanies(userCompanies).length > 1;
}

export function shouldRequireCompanySelection(input: {
  userCompanies?: UserCompany[] | null;
  requestedCompanyId?: string | null;
}): boolean {
  if (input.requestedCompanyId?.trim()) {
    return false;
  }
  return hasMultipleVisibleCompanies(input.userCompanies);
}

export function resolveStudiesOrganizationContext(input: {
  companyId?: string | null;
  userCompanies?: UserCompany[] | null;
}): StudiesOrgDecision {
  if (input.companyId?.trim()) {
    return 'allowed';
  }
  if (getVisibleUserCompanies(input.userCompanies).length === 0) {
    return 'allowed';
  }
  return 'select-company';
}
